var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 24023",
    d: "M23.5714 12C23.5714 18.3907 18.3907 23.5714 12 23.5714C5.60928 23.5714 0.428571 18.3907 0.428571 12C0.428571 5.60928 5.60928 0.428571 12 0.428571C18.3907 0.428571 23.5714 5.60928 23.5714 12Z",
    strokeWidth: 0.857143,
    stroke: "#C7CBD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepInactive);
export default __webpack_public_path__ + "static/media/step-inactive.12353439f3d4872c14ba79c12d1e38c3.svg";
export { ForwardRef as ReactComponent };